'use client';

import { c as _c } from "react/compiler-runtime";
import { useRef } from 'react';
import { useScroll } from 'framer-motion';

// ----------------------------------------------------------------------

export function useScrollProgress(t0) {
  const $ = _c(4);
  const target = t0 === undefined ? "document" : t0;
  const elementRef = useRef(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      container: elementRef
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const options = t1;
  const {
    scrollYProgress,
    scrollXProgress
  } = useScroll(target === "container" ? options : undefined);
  let t2;
  if ($[1] !== scrollXProgress || $[2] !== scrollYProgress) {
    t2 = {
      elementRef,
      scrollXProgress,
      scrollYProgress
    };
    $[1] = scrollXProgress;
    $[2] = scrollYProgress;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}